'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _SdkConfig = require('../../../SdkConfig');

var _SdkConfig2 = _interopRequireDefault(_SdkConfig);

var _ScalarAuthClient = require('../../../ScalarAuthClient');

var _ScalarAuthClient2 = _interopRequireDefault(_ScalarAuthClient);

var _ScalarMessaging = require('../../../ScalarMessaging');

var _ScalarMessaging2 = _interopRequireDefault(_ScalarMessaging);

var _Modal = require('../../../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _languageHandler = require('../../../languageHandler');

var _AccessibleButton = require('./AccessibleButton');

var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2017 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var ManageIntegsButton = function (_React$Component) {
    (0, _inherits3.default)(ManageIntegsButton, _React$Component);

    function ManageIntegsButton(props) {
        (0, _classCallCheck3.default)(this, ManageIntegsButton);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ManageIntegsButton.__proto__ || (0, _getPrototypeOf2.default)(ManageIntegsButton)).call(this, props));

        _this.state = {
            scalarError: null
        };

        _this.onManageIntegrations = _this.onManageIntegrations.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(ManageIntegsButton, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            _ScalarMessaging2.default.startListening();
            this.scalarClient = null;

            if (_SdkConfig2.default.get().integrations_ui_url && _SdkConfig2.default.get().integrations_rest_url) {
                this.scalarClient = new _ScalarAuthClient2.default();
                this.scalarClient.connect().done(function () {
                    _this2.forceUpdate();
                }, function (err) {
                    _this2.setState({ scalarError: err });
                    console.error('Error whilst initialising scalarClient for ManageIntegsButton', err);
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _ScalarMessaging2.default.stopListening();
        }
    }, {
        key: 'onManageIntegrations',
        value: function onManageIntegrations(ev) {
            var _this3 = this;

            ev.preventDefault();
            if (this.state.scalarError && !this.scalarClient.hasCredentials()) {
                return;
            }
            var IntegrationsManager = _index2.default.getComponent("views.settings.IntegrationsManager");
            this.scalarClient.connect().done(function () {
                _Modal2.default.createDialog(IntegrationsManager, {
                    src: _this3.scalarClient !== null && _this3.scalarClient.hasCredentials() ? _this3.scalarClient.getScalarInterfaceUrlForRoom(_this3.props.room) : null
                }, "mx_IntegrationsManager");
            }, function (err) {
                _this3.setState({ scalarError: err });
                console.error('Error ensuring a valid scalar_token exists', err);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var integrationsButton = _react2.default.createElement('div', null);
            var integrationsWarningTriangle = _react2.default.createElement('div', null);
            var integrationsErrorPopup = _react2.default.createElement('div', null);
            if (this.scalarClient !== null) {
                var integrationsButtonClasses = (0, _classnames2.default)({
                    mx_RoomHeader_button: true,
                    mx_RoomHeader_manageIntegsButton: true,
                    mx_ManageIntegsButton_error: !!this.state.scalarError
                });

                if (this.state.scalarError && !this.scalarClient.hasCredentials()) {
                    integrationsWarningTriangle = _react2.default.createElement('img', {
                        src: require("../../../../res/img/warning.svg"),
                        title: (0, _languageHandler._t)('Integrations Error'),
                        width: '17'
                    });
                    // Popup shown when hovering over integrationsButton_error (via CSS)
                    integrationsErrorPopup = _react2.default.createElement(
                        'span',
                        { className: 'mx_ManageIntegsButton_errorPopup' },
                        (0, _languageHandler._t)('Could not connect to the integration server')
                    );
                }

                integrationsButton = _react2.default.createElement(
                    _AccessibleButton2.default,
                    { className: integrationsButtonClasses,
                        onClick: this.onManageIntegrations,
                        title: (0, _languageHandler._t)('Manage Integrations')
                    },
                    integrationsWarningTriangle,
                    integrationsErrorPopup
                );
            }

            return integrationsButton;
        }
    }]);
    return ManageIntegsButton;
}(_react2.default.Component);

exports.default = ManageIntegsButton;


ManageIntegsButton.propTypes = {
    room: _propTypes2.default.object.isRequired
};
module.exports = exports['default'];
//# sourceMappingURL=ManageIntegsButton.js.map